import * as React from 'react'
import { useTranslation } from 'react-i18next'
import useCurrencies from '../../../../hooks/useCurrencies'
import { formatInlineCurrency } from '../../../../helpers/numberHelper'
import { UNKNOWN_CURRENCY } from '../../../../config/i18nConfig'
import { CurrencyAmount } from './timeCalendarHelper'

type Props = {
    amounts: CurrencyAmount[]
    // Translation key with a {{value}} placeholder; omitted renders the amounts on their own.
    labelKey?: string
}

/**
 * Formats amounts per currency. Time entries of several currencies are never converted, so every currency is
 * listed separately. Without amounts there is no currency either, so that case gets its own text.
 */
export default function CalendarTurnover(props: Props) {
    const { t: translate } = useTranslation()
    const { getCurrency } = useCurrencies()

    if (!props.amounts?.length) {
        return <span>{translate('time.calendar.turnover.none')}</span>
    }

    const value = props.amounts.map(entry => formatInlineCurrency(entry.amount, getCurrency(entry.currency) ?? UNKNOWN_CURRENCY)).join(' | ')

    return <span>{props.labelKey ? translate(props.labelKey, { value }) : value}</span>
}

/**
 * Same formatting as {@link CalendarTurnover}, for places that need a plain string.
 */
export function formatAmounts(amounts: CurrencyAmount[], getCurrency: (alpha: string) => any): string {
    return amounts.map(entry => formatInlineCurrency(entry.amount, getCurrency(entry.currency) ?? UNKNOWN_CURRENCY)).join(' | ')
}
